import { Button, Group, Modal, Stack } from "@mantine/core";
import type { ReactNode } from "react";

import classes from "./ConfirmModal.module.css";

export interface ConfirmModalProps {
  opened: boolean;
  title: string;
  /** What happens if the user confirms, said plainly. */
  children: ReactNode;
  confirmLabel: string;
  /** Red for a destructive action (the default); the primary color for live's leave prompt. */
  confirm?: "danger" | "primary";
  /** The way back: "Cancel", or live's "Stay" on its leave prompt. */
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
  /** The failure of the last attempt, rendered under the text. */
  error?: ReactNode;
}

/**
 * Asks before a destructive action (audit frontend C.20). Closing it, by the X, Escape or a click
 * outside, only cancels: it never performs the action (audit frontend B.11). The live app's modal:
 * 24px padding, an 18px title, the dialog shadow.
 */
export function ConfirmModal(props: ConfirmModalProps) {
  const { opened, title, children, confirmLabel, confirm, cancelLabel, onConfirm, onCancel } = props;
  const { pending, error } = props;
  return (
    <Modal
      opened={opened}
      onClose={onCancel}
      title={title}
      centered
      padding={24}
      classNames={{ content: classes.content, title: classes.title }}
    >
      <Stack gap="md">
        {children}
        {error}
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>
            {cancelLabel ?? "Cancel"}
          </Button>
          <Button
            {...(confirm === "primary" ? {} : { color: "red" })}
            onClick={onConfirm}
            loading={pending === true}
          >
            {confirmLabel}
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
